import axios from 'axios'

class SubscriptionsService {
  getPlans = () =>
    axios({
      url: 'admin/subscriptions/plans',
      method: 'GET',
    })

  createPlan = (data) =>
    axios({
      url: 'admin/subscriptions/plans',
      method: 'POST',
      data,
    })

  updatePlan = (id, data) =>
    axios({
      url: `admin/subscriptions/plans/${id}`,
      method: 'PUT',
      data,
    })

  getSubscriptions = () =>
    axios({
      url: 'admin/subscriptions',
      method: 'GET',
    })

  getSubscriptionById = (id) =>
    axios({
      url: `admin/subscriptions/${id}`,
      method: 'GET',
    })

  createSubscription = (data) =>
    axios({
      url: 'admin/subscriptions',
      method: 'POST',
      data,
    })

  updateSubscription = (id, data) =>
    axios({
      url: `admin/subscriptions/${id}`,
      method: 'PUT',
      data,
    })

  getCustomerSubscriptions = (params) =>
    axios({
      url: 'admin/subscriptions/customer-subscriptions/list',
      method: 'GET',
      params,
    })

  exportSubscriptions = ({ startDate, finishDate }) =>
    axios({
      url: 'admin/subscriptions/customer-subscriptions/export',
      method: 'GET',
      params: {
        startDate,
        finishDate,
      },
      responseType: 'blob',
    })
}

export default new SubscriptionsService()
